import { render, staticRenderFns } from "./BrowserCheck.vue?vue&type=template&id=d7842eee&scoped=true&"
import script from "./BrowserCheck.vue?vue&type=script&lang=ts&"
export * from "./BrowserCheck.vue?vue&type=script&lang=ts&"
import style0 from "./BrowserCheck.vue?vue&type=style&index=0&id=d7842eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7842eee",
  null
  
)

export default component.exports